import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TK2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TK2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_738)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_1813_738"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_738)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.47086 7.54754L1.80669 7.95851L2.06454 7.26859L1.5 6.74628H2.18475L2.47086 6L2.6892 6.74628H3.375L2.88076 7.26859L3.12274 7.95851L2.47086 7.54754Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.47086 4.54754L4.80669 4.95851L5.06454 4.26859L4.5 3.74628H5.18475L5.47086 3L5.6892 3.74628H6.375L5.88076 4.26859L6.12274 4.95851L5.47086 4.54754Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.47086 7.54754L7.80669 7.95851L8.06454 7.26859L7.5 6.74628H8.18475L8.47086 6L8.6892 6.74628H9.375L8.88076 7.26859L9.12274 7.95851L8.47086 7.54754Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.47086 10.5475L4.80669 10.9585L5.06454 10.2686L4.5 9.74628H5.18475L5.47086 9L5.6892 9.74628H6.375L5.88076 10.2686L6.12274 10.9585L5.47086 10.5475Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.6313 4.09741C15.5687 5.61028 5.50577 12.409 5.50577 12.409H22.2691C22.1017 12.3716 21.9455 12.3405 21.7982 12.3111C20.5677 12.0661 19.9602 11.9452 18.6313 9.29789C17.1434 6.33382 18.6313 4.09741 18.6313 4.09741ZM4.96165 13.474L4.73242 14.0439L4.96165 14.6702L22.0269 15.0001L22.4999 14.1303L22.0269 13.5041L4.96165 13.474Z"
            fill="#FECA00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_738">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TK2418Icon;
